import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  loadingById: false,
  saveLoading: false,
  technicalKnowledgesLength: 0,
  technicalKnowledges: [],
  technicalKnowledge: {},
  technicalKnowledgeError: "",
  formError: "",
  formErrorJson: {},
};

export default function TechnicalKnowledgeReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADING_TECHNICAL_KNOWLEDGE:
      return { ...state, loading: action.payload };
    case actions.LOADING_TECHNICAL_KNOWLEDGE_BY_ID:
      return { ...state, loadingById: action.payload };
    case actions.SAVE_LOADING_TECHNICAL_KNOWLEDGE:
      return { ...state, saveLoading: action.payload };
    case actions.GET_TECHNICAL_KNOWLEDGE:
      return {
        ...state,
        technicalKnowledges: action.payload.technicalKnowledges,
        technicalKnowledgesLength: action.payload.technicalKnowledgesLength,
      };
    case actions.GET_TECHNICAL_KNOWLEDGE_BY_ID:
      return {
        ...state,
        technicalKnowledge: action.payload,
      };
    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };
    case actions.FORM_FAIL_JSON:
      return { ...state, formErrorJson: action.payload };
    case actions.TECHNICAL_KNOWLEDGE_FAIL:
      return { ...state, technicalKnowledgeError: action.payload };
    default:
      return state;
  }
}
